import React from "react";
import "./Spinner.css";

const Spinner = ({ size = "default" }) => {
  const dim = size === "small" ? 16 : size === "large" ? 40 : 24;
  return (
    <span
      className="qt-spinner"
      style={{ width: dim, height: dim }}
      role="status"
      aria-label="Loading"
    />
  );
};

export default Spinner;
